<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :width="width"
    :isHide="isHide"
  >
    <div slot="content">
      <el-form ref="form" label-width="140px" :model="dataForm">
        <el-form-item label="项目名称：">
          {{ dataForm.Name }}
        </el-form-item>
        <el-form-item label="封面图：">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            :on-preview="onPicPreview"
            :file-list="pictureList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <!-- <div class="el-upload__tip" slot="tip">支持扩展名：.jpg</div> -->
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img
              style="width: 80%; height: 70%; margin-left: 10%"
              :src="dialogImageUrl"
              alt
            />
          </el-dialog>
        </el-form-item>
        <el-form-item label="项目类别：">
          {{ dataForm.Type }}
        </el-form-item>
        <el-form-item label="项目实施单位：">
          {{ dataForm.WorkUnit }}
        </el-form-item>
        <el-form-item label="负责人：">
          {{ dataForm.Leader }}
        </el-form-item>
        <el-form-item label="设立时间：">
          {{ (dataForm.EstablishTime * 1000) | formatDate2 }}
        </el-form-item>
        <el-form-item label="预算金额：">
          {{ dataForm.Budget }}
        </el-form-item>
        <el-form-item label="资金来源：">
          {{ showSource(dataForm.Source) }}
        </el-form-item>
        <el-form-item label="拨款公益项目：">
          {{ dataForm.ProjectName }}
        </el-form-item>
        <el-form-item label="受赠者：">
          {{ showDirection(dataForm.Direction) }}
        </el-form-item>
        <el-form-item label="附件：">
          <el-upload
            class="upload-demo"
            action="/api/File/FileUpload"
            multiple
            :on-preview="onFilePreview"
            :file-list="fileList"
          >
          </el-upload>
        </el-form-item>
        <el-form-item label="项目介绍：">
          <of-tinymce
            ref="editor"
            v-model="dataForm.Describe"
            :height="500"
            :isEdit="true"
          ></of-tinymce>
        </el-form-item>
      </el-form>
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import OfTinymce from "@/components/controls/of_editor/of_tinymce_readonly";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";
import { mapGetters } from "vuex";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataForm: {}, //表单对象
      width: "80%",
      pictureList: [], //封面图数组
      fileList: [], //附件数组
      dialogVisible: false,
      dialogImageUrl: "",
    };
  },
  components: {
    workbenchDetail,
    OfTinymce,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    showSource() {
      return (data) => {
        switch (data) {
          case 0:
            return "社会捐赠";
          case 1:
            return "财政拨款";
          case 2:
            return "其他";
        }
      };
    },
    showDirection() {
      return (data) => {
        return data == 1 ? "定向" : "非定向";
      };
    },
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QueryImplementProjectById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          that.getImg();
          that.getfile();
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditImplementProject(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    //初始化图片
    getImg() {
      let that = this;
      if (that.dataForm.CoverMap || that.dataForm.CoverMap != null) {
        let params = { Id: that.dataForm.CoverMap };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.pictureList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //初始化附件
    getfile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //图片查看
    onPicPreview(file) {
      let that = this;
      that.dialogImageUrl =
        "/api/File/Download?Id=" + file.response.Data.FileId;
      that.dialogVisible = true;
    },
    //附件下载
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload--text {
  display: none !important;
}
</style>
